import { BadgeCheck, Sparkles } from "lucide-react";
import { ACCENTS } from "../../../lib/accents";
import { cn } from "../../../lib/cn";
import { BADGES, type BadgeId } from "../people";

/** A member badge pill ("Mentor Parent", "Verified Nurse"): -700 text on a light wash. */
export function BadgeChip({ badge, className }: { badge: BadgeId; className?: string }) {
  const info = BADGES[badge];
  const accent = ACCENTS[info.accent];
  const Icon = info.verified ? BadgeCheck : Sparkles;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold",
        accent.softBg,
        accent.border,
        accent.text,
        className,
      )}
    >
      <Icon className="h-3 w-3" aria-hidden />
      {info.label}
    </span>
  );
}
